import React from "react";

export default function NotFoundPage() {
  return <div>404 Not found</div>;
}
